import { tv } from 'tailwind-variants'

export const preLoginVariants = tv({
  slots: {
    container: 'flex h-screen bg-white',
    image: 'flex h-full w-[40%] items-center justify-center bg-pre-login-background bg-cover',
    stages:
      'flex h-full w-[60%] ml-[-20px] items-center rounded-l-deca z-12 bg-white shadow-[-25px_0px_20px_-20px_rgba(0,0,0,0.20)]'
  }
})
